import white from "./white";

export const close = {
  "close/white": white,
};
